<template>
    <div id="app">

        <el-row :gutter="20">
            <el-col :span="8">
                <el-card class="box-card" shadow="hover" style="margin-bottom: 20px;">
                    <div class="p_card_icon">
                        <i class="fa fa-address-card-o fa-5x"/>
                    </div>
                    <div class="p_card_info">
                        <ul>
                            <li style="font-size: 20px;margin-bottom: 10px;">{{nameEng}}</li>
                            <li>{{roleName}}</li>
                        </ul>
                    </div>
                    <div class="dashboard_line"></div>
                    <div class="text item">
                        <div style="font-size: 16px;margin-bottom: 5px;">總審核保單 : {{totalApprovedPolicy}} 張</div>
                        <div style="font-size: 16px;margin-bottom: 5px;">總審核保費(港元) :
                            {{totalApprovedPremium|currency('')}}
                        </div>
                    </div>
                </el-card>

                <el-card class="box-card" shadow="hover">
                    <div slot="header" class="clearfix">
                        <span style="font-size: 20px;">{{new Date().getFullYear()}}年</span>
                    </div>
                    <div class="text item">
                        <div style="font-size: 15px;margin-bottom: 5px;">審核保單 : {{yearlyTotalApprovedPolicy}} 張</div>
                        <div style="font-size: 15px;margin-bottom: 5px;">審核保費(港元) :
                            {{yearlyTotalApprovedPremium|currency('')}}
                        </div>
                        <div style="font-size: 15px;margin-bottom: 5px;">年度目標(港元) : {{yearlyTarget|currency('')}}</div>
                    </div>
                </el-card>

            </el-col>

            <el-col :span="16">
                <el-row :gutter="20">
                    <!--<el-col :span="8">
                        <el-card shadow="hover" :body-style="{padding: '0px'}">
                            <div class="grid-content grid-con-1">
                                <i class="fa fa-underline fa-5x grid-con-icon"></i>
                                <div class="grid-cont-right">
                                    <div class="grid-num blink">{{nbPendingCases}}</div>
                                    <div style="font-size: 24px;">核保中</div>
                                </div>
                            </div>
                        </el-card>
                    </el-col>
                    <el-col :span="8">
                        <el-card shadow="hover" :body-style="{padding: '0px'}">
                            <div class="grid-content grid-con-2">
                                <i class="el-icon-service grid-con-icon"></i>
                                <div class="grid-cont-right">
                                    <div class="grid-num blink">{{afPendingCases}}</div>
                                    <div style="font-size: 24px;">售後</div>
                                </div>
                            </div>
                        </el-card>
                    </el-col>-->
                    <el-col :span="6" v-if="$store.getters.systemCpy==1">
                        <el-card shadow="hover" :body-style="{padding: '0px'}">
                            <div class="grid-content grid-con-3">
                                <i class="fa fa-mortar-board fa-5x grid-con-icon"></i>
                                <div class="grid-cont-right">
                                    <div class="grid-num blink">{{complianceCases}}</div>
                                    <div style="font-size: 24px;">法規閱讀</div>
                                </div>
                            </div>
                        </el-card>
                    </el-col>
                    <el-col :span="6" v-if="$store.getters.systemCpy==1">
                        <el-card shadow="hover" :body-style="{padding: '0px'}">
                            <div class="grid-content grid-con-6">
                                <i class="fa fa-cube fa-5x grid-con-icon"></i>
                                <div class="grid-cont-right">
                                    <div class="grid-num blink">{{productTrainCases}}</div>
                                    <div style="font-size: 24px;">產品培訓</div>
                                </div>
                            </div>
                        </el-card>
                    </el-col>
                    <el-col :span="6" v-if="$store.getters.systemCpy==1">
                        <el-card shadow="hover" :body-style="{padding: '0px'}">
                            <div class="grid-content grid-con-7" >
                                <i class="fa fa-bullhorn fa-5x grid-con-icon" ></i>
                                <div class="grid-cont-right">
                                    <div class="grid-num blink">{{memoCases}}</div>
                                    <div style="font-size: 24px;">重要通告</div>
                                </div>
                            </div>
                        </el-card>
                    </el-col>
                    <el-col :span="6" v-if="$store.getters.systemCpy==1&&$store.getters.staff.staffType==3">
                        <el-card shadow="hover" :body-style="{padding: '0px'}">
                            <div class="grid-content grid-con-8" >
                                <i class="fa fa-bell fa-5x grid-con-icon" ></i>
                                <div class="grid-cont-right">
                                    <div class="grid-num blink">{{staffMemoCases}}</div>
                                    <div style="font-size: 24px;">員工通告</div>
                                </div>
                            </div>
                        </el-card>
                    </el-col>
                </el-row>
                <el-row :gutter="20" style="margin-top: 10px;" v-if="$store.getters.staff.staffType==1||$store.getters.staff.staffType==3">
                    <el-col :span="24">
                        <el-card shadow="hover" :body-style="{padding: '0px'}" style="background-color: rgba(14, 199, 139, 0.79);border-radius: 15px;">
                            <div class="grid-content grid-con-8" @click="goInfo1">
                                <img src="../assets/mask.png" style="width: 100px;    margin-left: 15px;"/>
                                <div class="grid-cont-right">
                                    <div style="font-size: 24px;color: #FFFFFF">新型冠狀病毒快訊(HK)</div>
                                </div>
                            </div>
                        </el-card>
                    </el-col>
                </el-row>
                <el-row :gutter="20" style="margin-top: 10px;" v-if="$store.getters.staff.staffType==2||$store.getters.staff.staffType==3">
                    <el-col :span="24">
                        <el-card shadow="hover" :body-style="{padding: '0px'}" style="background-color: rgba(14, 199, 139, 0.79);border-radius: 15px;">
                            <div class="grid-content grid-con-8" @click="goInfo2">
                                <img src="../assets/mask.png" style="width: 100px;    margin-left: 15px;"/>
                                <div class="grid-cont-right">
                                    <div style="font-size: 24px;color: #FFFFFF">新型冠状病毒快讯(渠道)</div>
                                </div>
                            </div>
                        </el-card>
                    </el-col>
                </el-row>
                <!--<el-row :gutter="20" style="margin-top: 20px;">
                    <el-col :span="8">
                        <el-card shadow="hover" :body-style="{padding: '0px'}">
                            <div class="grid-content grid-con-4">
                                <i class="fa fa-exclamation-circle fa-5x grid-con-icon"></i>
                                <div class="grid-cont-right">
                                    <div class="grid-num blink">{{currentMonthRenewCases}}</div>
                                    <div style="font-size: 24px;">本月續保</div>
                                </div>
                            </div>
                        </el-card>
                    </el-col>
                    <el-col :span="8">
                        <el-card shadow="hover" :body-style="{padding: '0px'}">
                            <div class="grid-content grid-con-5">
                                <i class="fa fa-exclamation-circle fa-5x grid-con-icon"></i>
                                <div class="grid-cont-right">
                                    <div class="grid-num blink">{{nextMonthRenewCases}}</div>
                                    <div style="font-size: 24px;">下月續保</div>
                                </div>
                            </div>
                        </el-card>
                    </el-col>
                </el-row>-->

                <el-card shadow="hover" style="height:703px;margin-top: 20px;">
                    <div slot="header" class="clearfix">
                        <span style="color: black;font-size: 20px;">市場快訊</span>
                    </div>
                    <el-table :data="marketInfoList" :show-header="false" height="600" v-loading="marketInfoLoading"
                              style="width: 100%;font-size:14px;">
                        <el-table-column width="50">
                            <template slot-scope="scope">
                                <template>{{getType(scope.row.type)}}</template>
                            </template>
                        </el-table-column>
                        <el-table-column>
                            <template slot-scope="scope">
                                <div class="todo-item" style="cursor: pointer;" @click="marketInfoDetail(scope.row)">
                                    ({{getDate(scope.row.publicDate*1000)}}) {{scope.row.title}}</div>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-card>
            </el-col>
        </el-row>
        <el-row :gutter="20">
            <el-col :span="8">
                <el-card shadow="hover" :class="$store.getters.staff.staffType==3&&$store.getters.systemCpy==1?'business_1':$store.getters.staff.staffType==3&&$store.getters.systemCpy!=1?'business_3':'business_2'">
                    <canvas id="myChart2" width="400px" height="400px"></canvas>
                </el-card>
            </el-col>
        </el-row>


        <el-dialog :title="dialogName" :visible.sync="marketInfoVisible" width="1000px" top="1vh">
            <div>
                <div >發佈日期 : {{getDate(libraryDetail.publicDate)}}, 開始日期 : {{getDate(libraryDetail.startDate)}},
                    限期 : {{getDate(libraryDetail.endDate)}}</div>
                <div v-html="libraryDetail.content" style="word-break: break-all;margin-top: 20px;">

                </div>

                <div style="margin-top: 20px;">
                    附件列表 :
                    <ul v-for="file in fileList">
                        <li><i class="fa fa-file-pdf-o" style="margin-right: 10px;"/>
                            <span style="cursor: pointer;" @click="fileDownload(file)">{{file.fileName}}</span>
                        </li>
                    </ul>
                </div>
            </div>


            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="marketInfoVisible = false">關閉</el-button>
            </div>


        </el-dialog>

    </div>
</template>

<script>
    import axios from 'axios';
    import {queryMyMarketInfo, queryFileSubTypeOption, dashboardPage,queryMarketInfoById} from '../api/api';
    import Chart from 'chart.js';

    export default {
        name: "Dashboard",
        data() {
            return {
                nameEng: "",
                roleName: "",
                marketInfoTableloading: false,
                pager: {
                    page: 1,
                    size: 10,
                    total: 0
                },
                searchName: "",
                marketInfoList: [],
                datacollection: null,
                nbPendingCases: "",
                afPendingCases: "",
                complianceCases: "",
                productTrainCases:"",
                memoCases:"",
                staffMemoCases:"",
                totalApprovedPolicy: "",
                totalApprovedPremium: "",
                yearlyTarget: "",
                yearlyTotalApprovedPolicy: "",
                yearlyTotalApprovedPremium: "",
                currentMonthRenewCases: "",
                nextMonthRenewCases: "",
                marketInfoVisible:false,
                dialogName:'',
                libraryDetail:{
                    id:"",libraryId:"",title:"",content:"",publicDate:"",isDisplay:"",startDate:"",endDate:""
                },
                fileList:[],
                marketInfoLoading:false,
                currBusinessList:[],
                lastBusinessList:[],
                last2BusinessList:[],
                count:0

            }
        },
        methods: {
            goInfo2(){
                this.$router.push('/myInfo2');
            },
            goInfo1(){
                this.$router.push('/myInfo1');
            },
            fileDownload(file){
                if(file.id!=null && file.id!='' && file.id!=undefined){
                    window.location.href=axios.defaults.baseURL+'/file/download/?id='+file.id;
                }
            },
            queryFileSubTypeOption(val){
                return queryFileSubTypeOption(val).then(res=>{
                    if(res.errcode==200){
                        this.fileSubTypeOption=[];
                        let {data:fileSubTypeOption=[]}=res;
                        let temp = {id:null,label:'全部'};
                        this.fileSubTypeOption.push(temp);
                        fileSubTypeOption.forEach(v=>{
                            this.fileSubTypeOption.push(v);
                        })
                    }else{
                        this.$message.error(res.errmsg);
                    }
                }).catch((error)=>{
                    console.log("queryFileSubTypeOption Error");
                });
            },
            getType(val){
                if(val==null){
                    return "";
                }
                if(val!=null && val!='' && val!=undefined){
                    return this.fileSubTypeOption.find(v=>v.id==val).label
                }
            },
            initalLibraryDetail(){
                this.libraryDetail={
                    id:"",libraryId:"",title:"",content:"",publicDate:"",isDisplay:"",startDate:"",endDate:""
                }
            },
            marketInfoDetail(row){
                this.marketInfoVisible=true;
                this.initalLibraryDetail();
                this.resetForm("libraryDetail");
                this.fileList=[];
                return queryMarketInfoById(row.uuid).then(res=>{
                    if(res.errcode==200){
                        this.libraryDetail = Object.assign({},res.data);
                        this.libraryDetail.publicDate = this.libraryDetail.publicDate*1000;
                        this.libraryDetail.startDate = this.libraryDetail.startDate*1000;
                        this.libraryDetail.endDate = this.libraryDetail.endDate*1000;
                        this.fileList = this.libraryDetail.uploadFileList;
                        this.dialogName=this.libraryDetail.title;
                        this.dialogName = this.getType(this.libraryDetail.type) +" : " +this.dialogName;
                    }else{
                        this.$message.error(res.errmsg);
                    }
                });
            },

            queryDashboardPage() {
                let params = {staffId: this.$store.getters.staff.id, year: new Date().getFullYear()};
                return dashboardPage(params).then(res => {
                    if (res.errcode == 200) {
                        this.nbPendingCases = res.data.nbPendingCases;
                        this.afPendingCases = res.data.afPendingCases;
                        this.complianceCases = res.data.complianceCases;
                        this.productTrainCases = res.data.productTrainCases;
                        this.memoCases = res.data.memoCases;
                        this.staffMemoCases = res.data.staffMemoCases;
                        this.totalApprovedPolicy = res.data.totalApprovedPolicy;
                        this.totalApprovedPremium = res.data.totalApprovedPremium;
                        this.yearlyTarget = res.data.yearlyTarget;
                        this.yearlyTotalApprovedPolicy = res.data.yearlyTotalApprovedPolicy;
                        this.yearlyTotalApprovedPremium = res.data.yearlyTotalApprovedPremium;
                        this.currentMonthRenewCases = res.data.currentMonthRenewCases;
                        this.nextMonthRenewCases = res.data.nextMonthRenewCases;
                        res.data.currDashboardBusinessList.forEach(v=>{
                            this.currBusinessList.push(v.totalBusiness);
                        })
                        res.data.lastDashboardBusinessList.forEach(v=>{
                            this.lastBusinessList.push(v.totalBusiness);
                        })
                        res.data.last2DashboardBusinessList.forEach(v=>{
                            this.last2BusinessList.push(v.totalBusiness);
                        })
                        var ctx2 = document.getElementById("myChart2");
                        new Chart(ctx2, {
                            type: "line",
                            data: {
                                labels: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
                                datasets: [
                                    {
                                        label: new Date().getFullYear(),
                                        backgroundColor: "rgba(225,10,10,0.3)",
                                        borderColor: "rgba(225,103,110,1)",
                                        borderWidth: 1,
                                        pointStrokeColor: "#fff",
                                        pointStyle: "crossRot",
                                        data: this.currBusinessList,
                                        cubicInterpolationMode: "monotone",
                                        spanGaps: "false",
                                        fill: "false"
                                    },
                                    {
                                        label: (new Date().getFullYear()-1),
                                        backgroundColor: "rgb(100, 213, 114)",
                                        borderColor: "rgb(83, 195, 97)",
                                        borderWidth: 1,
                                        pointStrokeColor: "#fff",
                                        pointStyle: "crossRot",
                                        data: this.lastBusinessList,
                                        cubicInterpolationMode: "monotone",
                                        spanGaps: "false",
                                        fill: "false"
                                    },
                                    {
                                        label:(new Date().getFullYear()-2),
                                        backgroundColor: "rgb(65, 141, 255)",
                                        borderColor: "rgb(65, 141, 255)",
                                        borderWidth: 1,
                                        pointStrokeColor: "#fff",
                                        pointStyle: "crossRot",
                                        data: this.last2BusinessList,
                                        cubicInterpolationMode: "monotone",
                                        spanGaps: "false",
                                        fill: "false"
                                    }
                                ]
                            },
                            options: {}

                            //
                        })

                    } else {
                        this.$message.error(res.errmsg);
                    }
                });
            },
            queryMyMarketInfo(){
                this.marketInfoLoading=true;

                if(this.count==1){
                    let params={searchName:this.searchName,insuranceId:this.insuranceId,type:this.type};
                    return queryMyMarketInfo(params).then(res=>{
                        if(res.errcode==200){
                            this.marketInfoList=res.data;
                            this.marketInfoLoading=false;
                        }else{
                            this.$message.error(res.errmsg);
                        }
                    });
                    this.count=0;
                    return;
                }
                if (this.count < 1) {
                    this.count++;
                    setTimeout(this.queryMyMarketInfo, 1000);
                }


            },
            getType(val) {
                return this.fileSubTypeOption.find(v => v.id == val).label
            },
            //get marketInfo type
            queryFileSubTypeOption(val) {
                return queryFileSubTypeOption(val).then(res => {
                    if (res.errcode == 200) {
                        let {data: fileSubTypeOption = []} = res;
                        this.fileSubTypeOption = fileSubTypeOption;
                    } else {
                        this.$message.error(res.errmsg);
                    }
                }).catch((error) => {
                    console.log("queryFileSubTypeOption Error");
                });
            },
            getDate(value){
                if(value!=''&&value!=null&&value!=undefined){
                    let d=new Date(value);
                    let m=d.getMonth()+1;
                    if(m<10){
                        m = '0'+m;
                    }
                    let ds = d.getDate();
                    if(ds<10){
                        ds = '0' + ds;
                    }
                    return d.getFullYear()+'-'+m+'-'+ds;
                }
            },
            resetForm(formName){
                if (this.$refs[formName]!==undefined) {
                    this.$refs[formName].resetFields();
                }
            },
        },
        mounted() {
            this.queryDashboardPage();
            this.nameEng = this.$store.getters.staff.name;
                if(this.$store.getters.staff.role!=null&&this.$store.getters.staff.role!=''&&this.$store.getters.staff.role!=undefined){
                    this.roleName =this.$store.getters.staff.role.name
                }else{
                    this.roleName="用戶";
                }
            this.queryMyMarketInfo();
            this.queryFileSubTypeOption(3);

        }
    }
</script>

<style scoped>
    .grid-cont-right {
        flex: 1;
        text-align: center;
        font-size: 14px;
        color: #999;
    }

    .grid-con-icon {
        font-size: 50px;
        width: 100px;
        height: 100px;
        text-align: center;
        line-height: 100px;
        color: #fff;
    }

    .grid-con-1 .grid-con-icon {
        background: rgb(242, 94, 67);
    }

    .grid-con-1 .grid-num {
        font-size: 26px;
        margin-bottom: 20px;
        color: rgb(242, 94, 67);
    }

    .grid-con-2 .grid-con-icon {
        background: rgb(100, 213, 114);
    }

    .grid-con-2 .grid-num {
        font-size: 26px;
        margin-bottom: 20px;
        color: rgb(100, 213, 114);
    }

    .grid-con-3 .grid-con-icon {
        background: rgb(123, 107, 107);
    }

    .grid-con-3 .grid-num {
        font-size: 26px;
        margin-bottom: 20px;
        color: rgb(0, 0, 0);

    }

    .grid-con-4 .grid-con-icon {
        background: rgb(255, 73, 73);
    }

    .grid-con-4 .grid-num {
        font-size: 26px;
        margin-bottom: 20px;
        color: rgb(255, 73, 73);
    }

    .grid-con-5 .grid-con-icon {
        background: rgb(65, 141, 255);
    }

    .grid-con-5 .grid-num {
        font-size: 26px;
        margin-bottom: 20px;
        color: rgb(55, 110, 214);
    }

    .grid-con-6 .grid-con-icon {
        background: rgb(144, 28, 28);
    }

    .grid-con-6 .grid-num {
        font-size: 26px;
        margin-bottom: 20px;
        color: rgb(0, 0, 0);

    }

    .grid-con-7 .grid-con-icon {
        background: rgb(148, 201, 61);
    }

    .grid-con-7 .grid-num {
        font-size: 26px;
        margin-bottom: 20px;
        color: rgb(0, 0, 0);
    }

    .grid-con-8 .grid-con-icon {
        background: rgb(17, 82, 22);
    }

    .grid-con-8 .grid-num {
        font-size: 26px;
        margin-bottom: 20px;
        color: rgb(0, 0, 0);
    }

    .grid-content {
        display: flex;
        align-items: center;
        height: 100px;
    }

    .dashboard_line {
        border-bottom: 2px ridge #ffa960db;
        width: 100%;
        height: 2px;
        margin-bottom: 5px;
    }

    .p_card_icon {
        width: 70px;
    }

    .p_card_info {
        margin-top: -70px;
        margin-left: 76px;
    }

    /*閃閃*/
    /* 定义keyframe动画，命名为blink */
    @keyframes blink{
        0%{opacity: 1;}
        100%{opacity: 0;}
    }
    /* 添加兼容性前缀 */
    @-webkit-keyframes blink {
        0% { opacity: 1; }
        100% { opacity: 0; }
    }
    @-moz-keyframes blink {
        0% { opacity: 1; }
        100% { opacity: 0; }
    }
    @-ms-keyframes blink {
        0% {opacity: 1; }
        100% { opacity: 0;}
    }
    @-o-keyframes blink {
        0% { opacity: 1; }
        100% { opacity: 0; }
    }
    /* 定义blink类*/
    .blink{
        color: #dd4814;
        animation: blink 1s linear infinite;
        /* 其它浏览器兼容性前缀 */
        -webkit-animation: blink 1s linear infinite;
        -moz-animation: blink 1s linear infinite;
        -ms-animation: blink 1s linear infinite;
        -o-animation: blink 1s linear infinite;
    }
    /*閃閃*/

    .business_1{
        margin-top: -635px;
    }

    .business_2{
        margin-top: -524px;
    }
    .business_3{
        margin-top: -535px;
    }

</style>



// WEBPACK FOOTER //
// src/views/Dashboard.vue